import React from 'react';

const airlinePrice = (props) => {

    return (
        <span {...props} className={`u-fontSize16 u-fontWeightMedium u-flex align-items-center u-textColorDark u-phone-fontSize15 ${props.index === 0 ? 'u-textColorCheapest' : 'u-textColorDark'}`}>
            <span className={`u-fontWeightMedium`}>&#8377;</span>{Math.round(parseFloat(props.tf, 10)).toLocaleString()}
        </span>
    );
}

export default airlinePrice;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlinePrice/AirlinePrice.js